import Link from "next/link";
import getConfig from "next/config";

import Heading from "@components/Heading";

const {
  publicRuntimeConfig: {
    content: { websiteTitle },
  },
} = getConfig();

const PhoneBuyBackInfo = () => (
  <div>
    <Heading
      classesProp="text-[22px] text-center mb-[24px]"
      display="h3"
      as="h3"
      title="Buy Back Telefoane - Afla cat costa telefonul tau"
      font="semibold"
    />

    <div className="bg-white border border-black rounded-[12px] p-[20px] md:p-[30px] space-y-[18px] text-[14px] leading-[1.7] text-[#333333]">
      <div className="font-semibold italic">
        Buy Back pentru Telefoane - schimba-ti telefonul vechi simplu, rapid si
        sigur!
      </div>

      <div>
        Vrei sa iti schimbi telefonul vechi cu unul nou? Cu Programul Buy Back
        pentru Telefoane procesul este mai simplu ca niciodata.
      </div>

      <div>
        Nu mai trebuie sa te complici cu estimari nesigure sau discutii lungi.
        Evaluarea telefonului tau este la doar cateva click-uri distanta. Fie ca
        ai un iPhone, Samsung, Huawei sau alt model de telefon, cu Buy Back
        pentru Telefoane de pe site-ul nostru te bucuri de cea mai buna oferta!
      </div>

      <div className="font-semibold">
        Cum functioneaza programul de Buy-Back?
      </div>

      <ul className="list-disc pl-[18px] space-y-[6px]">
        <li>
          Calculeaza online – Introdu modelul telefonului si detaliile cerute
          pentru a afla o valoare estimativa.
        </li>

        <li>
          Mergi in magazin – Pentru stabilirea valorii reale, vino cu telefonul
          in cel mai apropiat magazin {websiteTitle}.
        </li>

        <li>
          Evaluare finala –Telefonul este verificat în magazin sau, dupa
          procedura magazinului, trimis la furnizor pentru confirmarea valorii
          finale
        </li>

        <li>
          Alege noul produs – Cu voucher-ul primit poti achizitiona orice produs
          din magazin in termen de 7 zile
        </li>
      </ul>

      <div className="font-semibold">
        Nu mai astepta! Beneficiaza acum de Buy Back si ia-ti telefonul pe care
        ti-l doresti! Descopera gama noastra variata de{" "}
        <Link href="/telefoane/cpl/">
          <a className="text-red-brand underline hover:text-bleu-hover">
            telefoane
          </a>
        </Link>{" "}
        la cel mai mic pret din Romania!
      </div>
    </div>
  </div>
);

export default PhoneBuyBackInfo;
